if (!customElements.get('product-cross-sell')) {
  customElements.define('product-cross-sell', class ProductCrossSell extends HTMLElement {
    connectedCallback() {
      this.renderToken = 0;
      this.init().catch((error) => {
        console.error('[Product cross-sell]', error);
        this.hide();
      });
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
      this.renderToken += 1;
    }

    readJson(selector, fallback) {
      try {
        return JSON.parse(this.querySelector(selector)?.textContent || JSON.stringify(fallback));
      } catch (_) {
        return fallback;
      }
    }

    async init() {
      this.sourceProduct = this.readJson('[data-product-cross-sell-source]', null);
      if (!this.sourceProduct?.id) return this.hide();

      this.excludedIds = this.readJson('[data-product-cross-sell-exclusions]', []);
      this.catalog = new Map(this.readJson('[data-product-cross-sell-catalog]', []).map((item) => [window.PerroneCrossSellEngine.normalizeId(item.id), item]));
      const response = await fetch(this.dataset.configUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Configuration request failed (${response.status})`);
      this.config = await response.json();

      await this.renderRecommendations();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.renderRecommendations(true).catch(() => this.hide());
        });
      }
    }

    async renderRecommendations(refresh = false) {
      const token = ++this.renderToken;
      if (refresh) {
        this.hide();
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = html.querySelector('product-cross-sell');
        if (!section || token !== this.renderToken) return;
        this.excludedIds = JSON.parse(section.querySelector('[data-product-cross-sell-exclusions]').textContent);
        this.catalog = new Map(JSON.parse(section.querySelector('[data-product-cross-sell-catalog]').textContent).map((item) => [window.PerroneCrossSellEngine.normalizeId(item.id), item]));
      }
      const recommendations = window.PerroneCrossSellEngine.recommend({
        config: this.config,
        sourceProducts: [this.sourceProduct],
        excludedIds: this.excludedIds,
        catalog: this.catalog,
        country: this.dataset.country,
        subtotal: Number(this.dataset.cartSubtotal || 0),
        mode: 'pdp',
        limitOverride: this.catalog.size
      });
      if (!recommendations.length) return this.hide();

      const selected = await window.PerroneCrossSellEngine.loadCards({
        candidates: recommendations, limit: 8, cardSection: this.dataset.cardSection
      });
      if (token !== this.renderToken || !this.isConnected) return;
      const cards = selected.map(({ candidate, card }, index) => {
        card.querySelectorAll('.quick-add__submit').forEach((button) => {
          const label = button.querySelector(':scope > span:not(.sold-out-message):not(.loading__spinner)');
          if (label) label.textContent = this.dataset.addLabel;
        });
        const item = document.createElement('li');
        item.className = 'grid__item';
        item.dataset.productCrossSellItem = candidate.id;
        item.dataset.index = String(index);
        item.innerHTML = card.innerHTML;
        item.querySelectorAll('quick-add-modal').forEach((modal) => {
          modal.dataset.cartCrossSellModalOwner = this.dataset.sectionId;
        });
        return item;
      });

      const list = this.querySelector('[data-product-cross-sell-list]');
      const renderedCards = cards.filter(Boolean);
      if (!list || !renderedCards.length) return this.hide();
      list.replaceChildren(...renderedCards);
      const content = this.querySelector('[data-product-cross-sell-content]');
      if (content) content.hidden = false;
    }

    hide() {
      const content = this.querySelector('[data-product-cross-sell-content]');
      if (content) content.hidden = true;
    }
  });
}
